import React from 'react';

import { locale } from '@trqk/utils';

export const AllUploadsSucceeded = ({
    input,
}: ToastRenderContentProps<
    OnGroupStoppedInput<FilenameInput, UploadAudioFileOutput>
>): JSX.Element => {
    const success = input?.success ?? [];

    const uploadOrUploads =
        success.length === 1
            ? locale.enUS.UPLOAD_AUDIO.TOASTS.ALL_UPLOADS_SUCCEEDED.UPLOAD_HAS
            : `${success.length} ${locale.enUS.UPLOAD_AUDIO.TOASTS.ALL_UPLOADS_SUCCEEDED.UPLOADS_HAVE}`;

    const successMessage = `${locale.enUS.UPLOAD_AUDIO.TOASTS.ALL_UPLOADS_SUCCEEDED.YOUR_AUDIO} ${uploadOrUploads} ${locale.enUS.UPLOAD_AUDIO.TOASTS.ALL_UPLOADS_SUCCEEDED.FINISHED}.`;

    return (
        <div style={{ width: 410 }} className="px-2">
            <div className="font-bold text-primary-500 tracking-wider mb-2">
                {
                    locale.enUS.UPLOAD_AUDIO.TOASTS.ALL_UPLOADS_SUCCEEDED
                        .GOOD_NEWS
                }
            </div>
            <div className="mb-2">{successMessage}</div>
        </div>
    );
};
